import { saveAs } from "file-saver";

/**
 * Converts a QR code element to a blob for download
 * @param {HTMLElement} qrElement - The QR code element containing a canvas
 * @returns {Promise<Blob|null>} - The blob or null if conversion failed
 */
export const convertQRToBlob = async (qrElement) => {
  return new Promise((resolve) => {
    const canvas = qrElement.querySelector("canvas");
    if (canvas) {
      try {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png');
      } catch (error) {
        console.error("Error converting canvas to blob:", error);
        // Fallback: try to get data URL and convert to blob
        try {
          const dataUrl = canvas.toDataURL('image/png');
          fetch(dataUrl)
            .then(res => res.blob())
            .then(blob => resolve(blob))
            .catch(() => resolve(null));
        } catch (e) {
          console.error("Fallback failed:", e);
          resolve(null);
        }
      }
    } else {
      resolve(null);
    }
  });
};

/**
 * Downloads a single QR code
 * @param {HTMLElement} qrElement - The QR code element containing a canvas
 * @param {string} fileName - The name for the downloaded file
 * @returns {Promise<boolean>} - True if successful, false otherwise
 */
export const downloadSingleQR = async (qrElement, fileName) => {
  try {
    const blob = await convertQRToBlob(qrElement);
    if (blob) {
      saveAs(blob, fileName);
      return true;
    } else {
      console.error("Failed to generate blob for QR code");
      return false;
    }
  } catch (error) {
    console.error("Error downloading QR code:", error);
    return false;
  }
};